import React, { useState } from "react";
import {
  Box,
  CodeIcon,
  Divider,
  DuplicateIcon,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "convertupleads-theme";
import Editor from "react-simple-code-editor";
import highlight from "../utils/highlight";

const PreviewAndEditor = ({
  title,
  children,
  value,
  language = "js",
  height,
  background = false,
}) => {
  const theme = useTheme();
  const [showEditor, setShowEditor] = useState(false);
  const [elementCode, setElementCode] = React.useState(value);

  const clickHandler = () => {
    navigator.clipboard.writeText(elementCode);
  };

  return (
    <>
      <Typography variant={"body2"} color={"text.secondary"}>
        {title}
      </Typography>
      <Box
        sx={{ border: `1px solid ${theme.palette.other.outlinedBorderDarker}` }}
      >
        <Box
          p={3}
          sx={
            background && {
              backgroundColor: theme.palette.other.dividerFillColor,
            }
          }
        >
          <Stack
            direction={"row"}
            justifyContent={"center"}
            alignItems={"baseline"}
            flexWrap={"wrap"}
            rowGap={2}
            spacing={2}
          >
            {children}
          </Stack>
        </Box>
        <Divider light />
        <Stack
          direction={"row"}
          justifyContent={"flex-end"}
          px={3}
          py={1}
          spacing={1}
        >
          <IconButton size={"small"} onClick={() => setShowEditor(!showEditor)}>
            <CodeIcon color={"action"} />
          </IconButton>
          <IconButton size={"small"} onClick={clickHandler}>
            <DuplicateIcon color={"action"} />
          </IconButton>
        </Stack>
        {showEditor && (
          <div style={{ maxHeight: height, overflow: "auto" }}>
            <Editor
              readOnly
              value={elementCode}
              onValueChange={(elementCode) => setElementCode(elementCode)}
              highlight={(code) => highlight(code, language)}
              padding={30}
              style={{
                fontFamily: "monospace",
                outline: "0px",
                background: "black",
                caretColor: "white",
              }}
            />
          </div>
        )}
      </Box>
    </>
  );
};

export default PreviewAndEditor;
